/**
 * Store seed data - flattens the nested company → stores authoring in
 * `company.seed.ts` into the relational rows the repositories serve, stamping
 * each store with its company's tenantId (API-faithful `StoreState`). 29
 * locations across the three retailer companies. `hoursLabel` is derived from
 * the structured weekly hours at seed time so display strings can never
 * contradict the authored schedule.
 */
import { StoreState } from '@core/models/store.state';
import { storeOpenState } from '@core/utils/store-hours';

import { seedCompanies } from '../tenant/company.seed';

export const seedStores = (): StoreState[] => {
  const now = new Date();
  return seedCompanies().flatMap(company =>
    company.stores.map(({ itemNoPrefix: _itemNoPrefix, ...store }) => ({
      ...store,
      tenantId: company.id,
      hoursLabel: storeOpenState(store.weekHours, now).label
    }))
  );
};
